export type RouteType = TypeRouteEnum.PRIVATE | TypeRouteEnum.PUBLIC;

export enum TypeRouteEnum {
    PRIVATE = 'private',
    PUBLIC = 'public',
}